import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "./BookingConfirmation.css";
import { usePostHog } from 'posthog-js/react';

const BookingConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const posthog = usePostHog();

  // Destructure appointment and userInfo from location.state (if available)
  const { appointment, userInfo } = location.state || {};

  // Always call this hook to redirect if data is missing
  useEffect(() => {
    if (!appointment || !userInfo) {
      navigate("/");
    }
  }, [appointment, userInfo, navigate]);

  useEffect(() => {
    if (appointment && userInfo && posthog) {
      posthog.capture('confirmation_screen_viewed', {
        date: appointment.date,
        time: appointment.start_time,
        email: userInfo.email,
      });
    }
  }, [appointment, userInfo, posthog]);

  // If data is missing, return null (we expect the useEffect above to redirect)
  if (!appointment || !userInfo) {
    return null;
  }

  // Format the appointment date and time
  const appointmentDate = appointment.date;
  const appointmentTime = new Date(appointment.start_time).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className="scheduler-container">
      {/* Top bar with company logo */}
      <div className="top-bar">
        <div className="logo">
          <Link to="https://www.colthomeservices.com/">
            <img src="/colt-single-logo.png" alt="Colt Home Services" />
          </Link>
        </div>
      </div>
      <div className="scheduler">
        <h2>Booking Confirmation</h2>
        <div className="confirmation-message">
            {/* Virtual pre-assessment notice - only for early morning customers */}
  {(userInfo.recentAssessment === "2t5" || userInfo.fuelSource === "gas") && (
    <p><strong>Thank you for scheduling a virtual pre-assessment with Colt Home Services!</strong></p>
  )}
          <p>Your appointment has been successfully booked!</p>
          <p>
            <strong>Date:</strong> {appointmentDate}
          </p>
          <p>
            <strong>Time:</strong> {appointmentTime}
          </p>
          <p>A confirmation email has been sent to {userInfo.email}.</p>
          <p>A confirmation text has been sent to {userInfo.phoneNumber}.</p>
        </div>
      </div>
    </div>
  );
};

export default BookingConfirmation;
